import { useCallback } from "react";

interface EyeDropperResult {
  sRGBHex: string;
}

declare global {
  interface Window {
    EyeDropper?: new () => { open: () => Promise<EyeDropperResult> };
  }
}

const isSupported = typeof window !== "undefined" && "EyeDropper" in window;

export const useEyeDropper = () => {
  const open = useCallback(async (): Promise<string> => {
    if (!window.EyeDropper) throw new Error("EyeDropper API not supported");

    const dropper = new window.EyeDropper();
    const result = await dropper.open();

    return result.sRGBHex;
  }, []);

  return { isSupported, open };
};
